import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";
import { ConnectionProvider, WalletProvider } from "@solana/wallet-adapter-react";
import { PropsWithChildren, useCallback, useMemo } from "react";
import { LedgerWalletAdapter,
  PhantomWalletAdapter,
  SlopeWalletAdapter,
  SolflareWalletAdapter,
  SolletExtensionWalletAdapter,
  SolletWalletAdapter,
  TorusWalletAdapter,
  GlowWalletAdapter
} from "@solana/wallet-adapter-wallets";
import { WalletDialogProvider } from "@solana/wallet-adapter-material-ui";
import * as web3 from '@solana/web3.js';

const CLUSTER = process.env.REACT_APP_CLUSTER as 'devnet' | 'mainnet-beta';
const RPC_SERVER = process.env.REACT_APP_RPC;
const RPC_WS_SERVER = process.env.REACT_APP_RPC_WSS;
const RPC_ENDPOINT = RPC_SERVER || web3.clusterApiUrl(CLUSTER);
const RPC_WS_ENDPOINT = RPC_WS_SERVER || web3.clusterApiUrl(CLUSTER);

const Context = ({children}: PropsWithChildren) => {
  
  const network = CLUSTER === 'mainnet-beta'? 
    WalletAdapterNetwork.Mainnet: 
    WalletAdapterNetwork.Devnet;

  const endpoint = useMemo(() => RPC_ENDPOINT, []);
  const wsEndpoint = useMemo(() => RPC_WS_ENDPOINT, []);

  const wallets = useMemo(
    () => [
      new PhantomWalletAdapter(),
      new GlowWalletAdapter(),
      new SlopeWalletAdapter(),
      new SolflareWalletAdapter({ network }),
      new TorusWalletAdapter(),
      new SolletWalletAdapter({ network }),
      new SolletExtensionWalletAdapter({ network }),
    ],
    [network]
  );

  const onError = useCallback((err: Error) => {
    console.error(err);
  }, []);

  return (
    <ConnectionProvider endpoint={endpoint} config={{wsEndpoint: wsEndpoint}}>
      <WalletProvider wallets={wallets} onError={onError} autoConnect={true}>
        <WalletDialogProvider>
          {children}
        </WalletDialogProvider>
      </WalletProvider>
    </ConnectionProvider>
  );
}

export default Context;